const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Everbean API endpoint (used for product view tracking, etc.)
window.EVERBEAN_API_URL = 'https://everbean.nitida.pt';